import { Component, Input } from "@angular/core";
import { ProgressColoring } from "@gtmhub/configuration";

@Component({
  selector: "gh-progress-bar",
  templateUrl: "./gh-progress-bar.component.html",
  styleUrls: ["./gh-progress-bar.component.less"],
})
export class GhProgressBarComponent {
  @Input() public score: number;

  constructor(private progressColoring: ProgressColoring) {}

  public getProgressColor(score: number): string {
    return this.progressColoring.getColorOrGeneric(score);
  }

  public getWidth(score: number): string {
    const multiplier = score * 100;
    return multiplier > 100 ? "100%" : multiplier + "%";
  }
}
